import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { MODULE_META, ROLE_SCOPE } from "@/config/modules";

const LABELS = {
  total_usuarios: "Usuários", administradores: "Administradores", tecnicos: "Técnicos", clientes: "Contas cliente",
  cadastros_clientes: "Clientes", os_abertas: "OS abertas", os_hoje: "OS hoje", os_finalizadas: "OS finalizadas", fazendas: "Fazendas",
  equipamentos: "Equipamentos", comissao_a_receber: "Comissão a receber",
  faturamento_mes: "Faturamento do mês", a_receber_mes: "A receber no mês", a_pagar_mes: "A pagar no mês",
};

const Stat = ({ k, v, i }) => (
  <div className="bg-white rounded-2xl border border-[#E2DDD3] p-5 fade-up" style={{ animationDelay: `${i * 60}ms` }} data-testid={`stat-${k}`}>
    <p className="text-xs font-bold uppercase tracking-wider text-[#5C6B66]">{LABELS[k] || k}</p>
    <p className="mt-2 font-display text-4xl font-extrabold text-[#1E4D2B]">{/comissao|_mes$/.test(k) ? Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : v}</p>
  </div>
);

const Tile = ({ m, i }) => {
  const Icon = MODULE_META[m.id].icon;
  return (
    <Link to={`/${m.id}`} data-testid={`quick-${m.id}`} style={{ animationDelay: `${i * 40}ms` }}
      className="group fade-up bg-white rounded-2xl border border-[#E2DDD3] p-5 min-h-[120px] flex flex-col justify-between hover:border-[#1E4D2B] hover:-translate-y-0.5 transition-[transform,border-color] active:scale-[0.98]">
      <div className="flex items-start justify-between">
        <span className="h-12 w-12 rounded-xl bg-[#E8F5E9] text-[#1E4D2B] flex items-center justify-center group-hover:bg-[#1E4D2B] group-hover:text-white transition-colors">
          <Icon className="h-6 w-6" />
        </span>
        {m.status === "soon" ? (
          <span className="text-[10px] uppercase font-bold px-2 py-1 rounded-full bg-[#C86D51]/15 text-[#B05A40]">Em breve</span>
        ) : <ArrowUpRight className="h-5 w-5 text-[#5C6B66]" />}
      </div>
      <p className="mt-4 font-semibold text-[#1B2A26] leading-tight">{m.label}</p>
    </Link>
  );
};

export default function Dashboard() {
  const { user, modules } = useAuth();
  const [summary, setSummary] = useState({});
  useEffect(() => { api.get("/dashboard/summary").then(({ data }) => setSummary(data)).catch(() => {}); }, []);
  const first = user.name.split(" ")[0];

  return (
    <div data-testid="dashboard-page">
      <PageHeader eyebrow={user.role_label} title={`Olá, ${first}`} subtitle={ROLE_SCOPE[user.role]} />
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 mb-10">
        {Object.entries(summary).map(([k, v], i) => <Stat key={k} k={k} v={v} i={i} />)}
      </div>
      <h2 className="text-base md:text-lg font-bold mb-4">Acesso rápido</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
        {modules.filter((m) => m.id !== "dashboard").map((m, i) => <Tile key={m.id} m={m} i={i} />)}
      </div>
    </div>
  );
}
